import { Pipe, PipeTransform } from '@angular/core';
import {NgbDate} from '@ng-bootstrap/ng-bootstrap';

@Pipe({
    name: 'ngbDateToIso',
    standalone: false
})
export class NgbDateToIsoPipe implements PipeTransform {

  transform(date: NgbDate, ...args: any[]): any {
    if (date === null){
      return '';
    }
    return new Date(date.year, date.month - 1, date.day, 0, 0, 0, 0).toISOString();
  }

}
